import React, { Component } from "react";
import OCPEntry from "./OCPEntry";

class ProformaEntry extends Component {
  render() {
    return (
      <OCPEntry
        module="Proforma"
        Type="Profoma"
        No="Profoma"
        itemEntryPage="ProformaItemEntry"
      />
    );
  }
}

export default ProformaEntry;
